import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { getDatoLocale } from '../lib/datoLocale'

export const useDatoLocale = () => {
  const {
    access: { locale: accessLocale },
  } = useCurrentSession()

  const locale = getDatoLocale(accessLocale)

  return { locale }
}
